import { Injectable } from "@angular/core";
import { Validators } from "@angular/forms";
import { BaseControl, Container, Custom, DateTimePicker, Textbox } from "@app/shared";
import { environment } from '@env/environment';


export interface Consecutivo {
  consecutivo?: string;
}

export interface Alias {
  alias?: string;
}

export interface Tipo {
  tipo?: string;
}

@Injectable()
export class FilingStructureFormService {
  constructor() {}

  /**
   * Configración formulario para agregar o modificar una serie
   *
   * @param {SeriePredeterminada} [serie]
   * @returns {BaseControl<any>[]}
   * @memberof FilingStructureFormService
   */
  getFormConsecutive(objectModel?: any, restart_date?: boolean): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Container({
        class: "form-row",
        order: 3,
        key: "date_container",
        controls: [
          new Textbox({
            key: "name",
            type: "text",
            size: "col-12 col-lg-6",
            readonly: true,
            // value: objectModel ? objectModel.email : null,
            // validations: {
            //   validators: [Validators.required, Validators.email],
            //   messages: {
            //     required: 'Es necesario el email.',
            //     email: 'Porfa introduce un email válido.'
            //   }
            // }
          }),
          new Textbox({
            key: "structure",
            type: "Estructura",
            size: "col-12 col-lg-6",
            readonly: true,
            // value: objectModel ? objectModel.email : null,
            // validations: {
            //   validators: [Validators.required, Validators.email],
            //   messages: {
            //     required: 'Es necesario el email.',
            //     email: 'Porfa introduce un email válido.'
            //   }
            // }
          }),
        ],
      }),
    ];

    return controls.sort((a, b) => a.order - b.order);
  }

  /**
   * Construye y retorna el formulario de agregar o odificar un tipo documental
   *
   * @param {TipoDocumentalPredeterminado} [typeDocumentary]
   * @returns {BaseControl<any>[]}
   * @memberof FilingStructureFormService
   */
  getFormRadicade(objectModel?: any): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Textbox({
        key: "alias",
        value: objectModel
          ? objectModel.data
            ? objectModel.data.alias
              ? objectModel.data.alias
              : null
            : null
          : null,
        label: "Alias",
        placeholder: "Alias del radicado",
        describe: 'Ejemplo para definir el alias: {a}',
        order: 1,
        validations: {
          validators: [Validators.required],
        },
      }),
      new Custom({
        key: "tipo",
        label: "Tipo",
        value: objectModel ? (objectModel.data ? (objectModel.data.tipo ? objectModel.data.tipo : null) : null) : null,
        order: 2,
        size: "col-12 col-lg-6",
        template: objectModel.modalTmpltTertiary,
        placeholder: "Seleccione el tipo",
        validations: {
          validators: [Validators.required],
        },
      }),
      new Custom({
        key: "consecutivo",
        label: "Consecutivo",
        order: 3,
        value: objectModel
          ? objectModel.data
            ? objectModel.data.consecutivo
              ? objectModel.data.consecutivo
              : null
            : null
          : null,
        size: "col-12 col-lg-6",
        condictions: [
          {
            campoDepende: 'tipo',
            siEs: 'Igual',
            valor: 8,
            accion: 'Mostrar'
          }
        ],
        template: objectModel.modalTmpltSecundary,
        placeholder: "Seleccione el consecutivo",
        validations: {
          validators: [Validators.required],
        }
      }),
      new Custom({
        key: "consulta",
        label: "Consulta",
        order: 4,
        value: objectModel
          ? objectModel.data
            ? objectModel.data.consulta
              ? objectModel.data.consulta
              : null
            : null
          : null,
        size: "col-12 col-lg-6",
        condictions: [
          {
            campoDepende: 'tipo',
            siEs: 'Igual',
            valor: 11,
            accion: 'Mostrar'
          }
        ],
        template: objectModel.modalTmpltSearch,
        placeholder: "Seleccione una consulta",
        validations: {
          validators: [Validators.required],
        }
      }),
      new Textbox({
        key: "digitos",
        type: 'number',
        value: objectModel
          ? objectModel.data
            ? objectModel.data.digitos
              ? objectModel.data.digitos
              : null
            : null
          : null,
        label: "Dígitos",
        placeholder: "Digitos del radicado",
        order: 5,
        validations: {
          validators: [],
        },
        condictions: [
          {
            campoDepende: 'tipo',
            siEs: 'Igual',
            valor: 8,
            accion: 'Mostrar'
          }
        ],
      }),
    ];

    return controls.sort((a, b) => a.order - b.order);
  }

  getFormEdit(objectModel?: any): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Container({
        class: "form-row",
        order: 1,
        controls: [
          new Textbox({
            key: "name",
            value: objectModel
              ? objectModel.data
                ? objectModel.data.nombre
                  ? objectModel.data.nombre
                  : null
                : null
              : null,
            label: "Nombre",
            size: "col-12 col-lg-6",
            placeholder: "Nombre de la estructura",
            validations: {
              validators: [Validators.required],
            },
          }),
          new Textbox({
            key: "structure",
            value: objectModel
              ? objectModel.data
                ? objectModel.data.estructura
                  ? objectModel.data.estructura
                  : null
                : null
              : null,
            label: "Estructura",
            describe: 'Ejemplo para definir la estructura: {a}-{b}-{c}',
            size: "col-12 col-lg-6",
            placeholder: "Forma de la estructura",
            validations: {
              validators: [Validators.required],
            },
          }),
        ],
      }),
    ];

    return controls.sort((a, b) => a.order - b.order);
  }

  getSerieSubDoc(objectModel?: any): BaseControl<any>[] {
    if (environment.hiddenExpTypeDocument){
      const controls: BaseControl<any>[] = [
        new Container({
          class: "form-row",
          order: 1,
          controls: [
            new Custom({
              key: 'serie',
              label: 'Serie',
              value: objectModel ? objectModel.data ? objectModel.data.serie ? objectModel.data.id_serie : null : null : null,
              size: 'col-12 col-lg-12',
              template: objectModel.serieTmplt,
              placeholder: 'Seleccione la serie',
              validations: {
                validators: [Validators.required]
              }
            }),
            new Custom({
              key: 'subserie',
              label: 'Subserie',
              size: 'col-12 col-lg-12',
              value: objectModel ? objectModel.data ? objectModel.data.subserie ? objectModel.data.id_subserie : null : null : null,
              template: objectModel.subserieTmpl,
              placeholder: 'Seleccione la subserie',
              validations: {
                validators: []
              }
            }),
            new Custom({
              key: 'tipo_documental',
              label: 'Tipo documental',
              size: 'col-12 col-lg-12',
              value: objectModel ? objectModel.data ? objectModel.data.tipo_documental ? objectModel.data.id_tipo_documental : null : null : null,
              template: objectModel.typeDocTmpl,
              placeholder: 'Seleccione el tipo documental',
              validations: {
                validators: []
              }
            })
          ],
        }),
      ];
      return controls.sort((a, b) => a.order - b.order);
    }else{
      const controls: BaseControl<any>[] = [
        new Container({
          class: "form-row",
          order: 1,
          controls: [
            new Custom({
              key: 'serie',
              label: 'Serie',
              value: objectModel ? objectModel.data ? objectModel.data.serie ? objectModel.data.id_serie : null : null : null,
              size: 'col-12 col-lg-12',
              template: objectModel.serieTmplt,
              placeholder: 'Seleccione la serie',
              validations: {
                validators: [Validators.required]
              }
            }),
            new Custom({
              key: 'subserie',
              label: 'Subserie',
              size: 'col-12 col-lg-12',
              value: objectModel ? objectModel.data ? objectModel.data.subserie ? objectModel.data.id_subserie : null : null : null,
              template: objectModel.subserieTmpl,
              placeholder: 'Seleccione la subserie',
              validations: {
                validators: [Validators.required]
              }
            }),
            new Custom({
              key: 'tipo_documental',
              label: 'Tipo documental',
              size: 'col-12 col-lg-12',
              value: objectModel ? objectModel.data ? objectModel.data.tipo_documental ? objectModel.data.id_tipo_documental : null : null : null,
              template: objectModel.typeDocTmpl,
              placeholder: 'Seleccione el tipo documental',
              validations: {
                validators: [Validators.required]
              }
            })
          ],
        }),
      ];
      return controls.sort((a, b) => a.order - b.order);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/documents/filing-structure/shared/filing-structure-form.service.ts